<template>
  <Disclosure v-slot="{ open }">
    <DisclosureButton
      class="text-md w-full cursor-pointer rounded-t-md border border-gray-300 bg-white py-2 hover:bg-gray-50"
    >
      <div class="flex w-full items-center">
        <div class="mx-auto flex justify-center">
          <p class="cursor-pointer select-none capitalize-first">{{ title }}</p>
        </div>
        <div class="mr-5 flex justify-end">
          <FontAwesomeIcon
            :icon="['fal', open ? 'chevron-up' : 'chevron-down']"
          />
        </div>
      </div>
    </DisclosureButton>
    <DisclosurePanel class="text-gray-500">
      <div
        class="rounded-b-md border-b border-l border-r border-gray-300 bg-white p-3"
      >
        <slot />
      </div>
    </DisclosurePanel>
  </Disclosure>
</template>

<script>
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'BaseDisclosure',
  components: {
    FontAwesomeIcon,
    Disclosure,
    DisclosureButton,
    DisclosurePanel
  },
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
